import { css } from '@emotion/react'
import styled from '@emotion/styled'

const baseStyles = ({ theme }) => css`
  label: footer;

  display: none;
  padding: ${theme.spacings.mega} 0;

  border-bottom: ${theme.spacings.bit} solid ${theme.colors.g500};

  ${theme.media.mega} {
    display: block;
    margin-top: 72px;
  }
`

export const Footer = styled('footer')(baseStyles)
